// extracted by mini-css-extract-plugin
export default {"amountInput":"amountInput___mHar2","focused":"focused___vLIQB","separator":"separator___fNVo0"};